<mat-card class="default-card grid-all">
    <mat-card-header>
        <mat-card-title>Options de l'attribut</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="form-panel-container">
            <form [formGroup]="formGroup" class="form">
                <div class="form-container">
                    <div class="form-item form-item-help">
                        <mat-checkbox class="with-info-icon accent-button" formControlName="trimPastedText" tabindex="9">
                            Ignorer les espaces au début et à fin du texte collé
                        </mat-checkbox>
                        <fa-icon
                            [icon]="faCircleInfo"
                            class="info-icon"
                            hubToolTip="Lorsque l'utilisateur colle du texte dans ce champ, les espaces situés au début et à fin du texte sont ignorés."
                            tooltipPosition="left"></fa-icon>
                    </div>
                    <div class="form-item form-item-help">
                        <mat-checkbox class="with-info-icon accent-button" formControlName="removeSpaceFromPastedText" tabindex="9">
                            Supprimer tous les espaces du texte collé
                        </mat-checkbox>
                        <fa-icon
                            [icon]="faCircleInfo"
                            class="info-icon"
                            hubToolTip="Lorsque l'utilisateur colle du texte dans ce champ, tous les espaces contenus dans le texte sont supprimés."
                            tooltipPosition="left"></fa-icon>
                    </div>
                </div>
            </form>
        </div>
    </mat-card-content>
    <mat-card-actions [class.single-child]="data.readonly">
        @if (data.readonly === true) {
        <button mat-raised-button class="accent-button" (click)="onCancel()">Ok</button>
        } @else {
        <button mat-stroked-button class="accent-button" (click)="onCancel()">Annuler</button>
        <button mat-raised-button class="accent-button" (click)="onConfirm()">Valider</button>
        }
    </mat-card-actions>
</mat-card>
